
import { Component, Prop, Watch, Vue, Emit } from "vue-property-decorator";
import vSelect from "vue-select";
import { validationMixin } from "vuelidate";
import {
	required,
	minLength,
} from "vuelidate/lib/validators";
import { renderChoiceEnum } from "@/models/Tasks/renderType";
import { ActionPlanTask } from "../../../store/tasks/types";
import { tryParseJson } from "@/filters";

@Component({
	components: {
		"vue-select": vSelect
	},
	mixins: [validationMixin],
	filters: { tryParseJson },
	validations: {
		choicesData: {
			choiceDescription: {
				required
			},
			choiceOptions: {
				required,
				minLength: minLength(2),
				$each: {
					required
				}
			}
		}
	}
})
export default class ChoicesTaskSetup extends Vue {
	@Prop() public value!: ActionPlanTask;

	private choiceListTypes: string[] = [];

	public choicesData: any = {
		choiceDescription: "",
		choiceOptions: ["", ""],
		selectedChoice: renderChoiceEnum.Listbox
	};

	public mounted() {
		// Get types from Enum and put them within choicesList string array. Couldn't directly use enum within template
		for (let item in renderChoiceEnum) {
			this.choiceListTypes.push(item);
		}

		this.loadFromTask();
		this.onValidationChange(this.$v.$invalid);
	}

	/** Watcher, when data changes within 'ChoicesData' call 'ChoicesSettingsChange'*/
	@Watch("choicesData", { deep: true, immediate: true })
	public onChoicesSettingsChange(newValue) {
		this.$v.$touch();

		if (!this.$v.$error) {
			this.onInput();
		}
	}

	/**
	 * Fires an input event containing the new task.
	 */
	@Emit("input")
	private onInput() {
		return {
			...this.value,
			taskText: this.choicesData.choiceDescription,
			taskData: {
				...this.choicesData
			}
		};
	}

	/**
	 * Watcher/emitter for the validation state of this component,
	 * bubbles up vuelidate's validation state when it changes.
	 */
	@Watch("$v.$invalid")
	private onValidationChange($invalid: boolean) {
		this.$emit("validate-task", !$invalid);
	}

	/**
	 * Loads the choice data from the current task
	 */
	private loadFromTask(): void {
		if (this.value?.taskData != null) {
			let taskData = this.value?.taskData || {};

			// If taskData is a string, try to parse it as JSON.
			if (taskData && typeof taskData === "string") {
				taskData = tryParseJson(taskData) || {};
			} else if (taskData && typeof taskData !== "object") {
				taskData = {};
			}

			this.choicesData = {
				...taskData
			};
		}
	}
}
